import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PublicDisplayLogin.scss';
import { getLanguage } from '../../context/languages/getLanguages';

const PublicDisplayLogin = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const language = getLanguage('en');
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) {
      setError('Password is required');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const response = await axios.post('/api/v1/public-display/verify', {
        token,
        password,
      });

      if (response.data.success && response.data.sessionToken) {
        // store only the session token, not the raw password
        localStorage.setItem(
          'publicDisplayAuth',
          JSON.stringify({
            token,
            sessionToken: response.data.sessionToken,
            timestamp: Date.now(),
          })
        );

        navigate(`/public-display-view/${token}`);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(
        err.response?.data ||
          language?.settings?.vendor?.modules?.publicDisplay?.invalidPassword ||
          'Invalid password. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="display_login_holder"
      style={{
        background: `url('/img/login-bg.jpeg') no-repeat center center`,
        backgroundSize: 'cover',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="container">
        <div className="logo-container">
          <img src={'/img/logo.svg'} alt="logo" className="login_logo" />
          <h4>
            {language?.settings?.vendor?.modules?.publicDisplay?.title ||
              'Public Display'}
          </h4>
        </div>
        <form onSubmit={handleLogin} autoComplete={'off'}>
          <div id="inputholder">
            <label>
              <div style={{ textAlign: 'left' }}>
                {language?.settings?.vendor?.modules?.publicDisplay?.password ||
                  'Password'}
              </div>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                autoFocus
              />
            </label>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" id="login_button">
              {language?.settings?.vendor?.modules?.publicDisplay
                ?.loginToDisplay || 'Login to Display'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PublicDisplayLogin;
